import { render, staticRenderFns } from "./Zskt.vue?vue&type=template&id=54c5db04&scoped=true"
import script from "./Zskt.vue?vue&type=script&lang=js"
export * from "./Zskt.vue?vue&type=script&lang=js"
import style0 from "./Zskt.vue?vue&type=style&index=0&id=54c5db04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_css-loader@6.11.0_webpack@5.105.4__lodash@4_729849d24245ac5da8661ad62b6d24d8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c5db04",
  null
  
)

export default component.exports